import { render, staticRenderFns } from "./ClientsRecentlyUpdated.vue?vue&type=template&id=45a200ee"
import script from "./ClientsRecentlyUpdated.vue?vue&type=script&lang=ts"
export * from "./ClientsRecentlyUpdated.vue?vue&type=script&lang=ts"
import style0 from "./ClientsRecentlyUpdated.vue?vue&type=style&index=0&id=45a200ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports